'use client';

import { Fragment } from 'react';
import { Container } from '@/components/common/container';
import { AccountApiKeysContent } from '@/app/(protected)/account/api-keys/content';
import { PageNavbar } from '@/app/(protected)/account/page-navbar';

export default function AccountApiKeysPage() {
  return (
    <Fragment>
      <PageNavbar />
      <Container>
        <AccountApiKeysContent />
      </Container>
    </Fragment>
  );
}
